module.exports = __webpack_public_path__ + "img/report.62c79647.png";